import React from 'react'
import { useParams } from 'react-router'
import Layout from '../components/Layout'
import Loader from '../components/Loader'
import { useCompanyAdmin } from '../hooks/CompanyAdmin/useCompanyAdmin'
import { useProduct } from '../hooks/Features/useProduct'
import Product from './Product/Product'

export default function EditProduct() {
  const { getProduct, product } = useProduct()
  const params = useParams()

  React.useEffect(() => {
    getProduct({ productId: params.productId })
  }, [params.productId])

  return <> {!product ? <Loader /> : <Product currentProduct={product} />}</>
}
